import { chain as _chain, isEmpty as _isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import {
  getOpenedProjectStatus,
  getProjectId,
} from '../../features/project/projectSlice';
import {
  getFavProjects,
  getAllProjects,
  getSearchPagedProjectsSelector,
} from '../../features/projects/pagedProjectsSlice';
import {
  isProjectArchived,
  isProjectInactive,
} from '../helpers/projectStatusesUtils';

export const getProjectStatus = (projectStatuses, projectId) => {
  return (
    projectId && projectStatuses[projectId] && projectStatuses[projectId].status
  );
};

export const getProjectStatusIcon = (projectStatuses, projectId) => {
  return projectId && projectStatuses[projectId]
    ? projectStatuses[projectId].icon
    : '';
};

export const useProjectsStatuses = (props) => {
  let projectList;
  const favProjects = useSelector(getFavProjects);
  const searchProjects = useSelector(getSearchPagedProjectsSelector);
  const projects = useSelector(getAllProjects);
  if (props?.isFavourite) {
    projectList = favProjects;
  } else if (props?.isSearch) {
    projectList = searchProjects;
  } else {
    projectList = projects;
  }
  const openProjectId = useSelector(getProjectId);
  const openProjectStatus = useSelector(getOpenedProjectStatus);
  let states = {};

  if (!_isEmpty(projectList)) {
    states = _chain(projectList)
      .filter((project) => project && project.id && project.status)
      .keyBy((project) => project.id)
      .mapValues((project) => {
        let icon = '';
        if (isProjectInactive(project.status)) {
          icon = 'pause';
        } else if (isProjectArchived(project.status)) {
          icon = 'archive';
        }

        return {
          status: project.status,
          icon,
        };
      })
      .value();
  }

  if (openProjectId && openProjectStatus) {
    let icon = '';

    if (isProjectInactive(openProjectStatus)) {
      icon = 'pause';
    } else if (isProjectArchived(openProjectStatus)) {
      icon = 'archive';
    }

    states[openProjectId] = { status: openProjectStatus, icon };
  }

  return states;
};
